import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowIcon } from './icons';
import { ArrowLinkStyled, ContainerStyled, EllipsisStyled, ItemLinkStyled, ItemStyled, ListStyled, } from './pagination.styles';
/**
 * A basic pagination component.
 */
export const Pagination = ({ totalPages = 10, activePage = 10, breakpoint = 4, onPaginationClick, ariaTranslations, customButtonColours, customArrowColour, }) => {
    const lastBreakpoint = breakpoint - 1;
    const isActiveWithinFirstBreakpoint = activePage < breakpoint;
    const isActiveWithinLastBreakpoint = activePage > totalPages - lastBreakpoint;
    const shouldNotBreak = totalPages <= breakpoint;
    const generatePaginationArray = (size) => Array(size)
        .fill('')
        .map((_, index) => index + 1);
    function linksArr() {
        if (shouldNotBreak) {
            return generatePaginationArray(totalPages);
        }
        if (isActiveWithinFirstBreakpoint) {
            const array = generatePaginationArray(breakpoint);
            return [...array];
        }
        if (isActiveWithinLastBreakpoint) {
            return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1];
        }
        return [1, '...', activePage - 1, activePage, activePage + 1];
    }
    const createPagination = linksArr().map((link, index) => {
        if (link === '...') {
            return (_jsx(ItemStyled, { children: _jsx(EllipsisStyled, { children: link }) }, `pagination-link-seperator-${index}`));
        }
        const isActive = link === activePage;
        const ariaLabel = isActive
            ? `${ariaTranslations.ariaLabelActive} ${link}`
            : `${ariaTranslations.ariaLabel} ${link}`;
        /*
          Key on li below will force safairi to render buttons properly. See AGE-238 for more details.
        */
        return (_jsx(ItemStyled, { children: _jsx(ItemLinkStyled, { overrideColours: customButtonColours, role: "button", title: `${link}`, "aria-label": ariaLabel, "aria-pressed": isActive, isActive: isActive, onClick: () => {
                    onPaginationClick(link);
                }, children: link }) }, `pagination-link-${link}-${activePage}`));
    });
    const isButtonDisabled = (direction) => {
        return direction === 'previous'
            ? activePage === 1
            : activePage === totalPages;
    };
    const PrevNextButton = (direction) => (_jsx(ArrowLinkStyled, { direction: direction, disabled: isButtonDisabled(direction), onClick: () => {
            const dir = direction === 'previous' ? -1 : 1;
            onPaginationClick(activePage + dir);
        }, customArrowColour: customArrowColour, children: _jsx(ArrowIcon, { "aria-label": direction === 'next'
                ? ariaTranslations.ariaNextPage
                : ariaTranslations.ariaPreviousPage }) }));
    return (_jsxs(ContainerStyled, { role: "navigation", children: [PrevNextButton('previous'), _jsx(ListStyled, { children: createPagination }), PrevNextButton('next')] }));
};
//# sourceMappingURL=pagination.js.map